module.exports = __webpack_public_path__ + "static/media/KREDIT-DINAMIS-940x94.5bccdd01.jpg";